import React from 'react';
import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import { ACCOUNT_REGISTRATION_FORM } from 'src/constants/FormNames';
import { TextField, BoxDouble, CheckboxField, Section } from 'src/components/Form';

import Button from 'jbc-front/components/Button';
import { ErrorsSection, TelFieldTh } from 'src/components';
import { registerAccount, getRegistrationErrors } from 'src/reducers/clients/accounts';
import { isEmail,isThai,isEnglish } from 'src/utils/CustomValidators';
import styles from './registration.scss';
import {useTranslation} from 'react-i18next'

const RawAccountRegistrationForm = ({ errors, handleSubmit, submit, pristine, submitting, agreeToTos }) => {
  const { t,i18n } = useTranslation()
  return (
  <form onSubmit={handleSubmit}>
    <ErrorsSection errors={errors} />

    <Section className={styles.wrap}>

      <TextField required label={t('features.Clients.components.BasicInfoSectionShow.viet_office_name')} name="clientName" maxLength="255" />

      <TextField label={t('features.Clients.components.BasicInfoSectionShow.eng_office_name')} name="clientNameEng" validate={isEnglish}/>

      <BoxDouble>
        <TextField name="userFirstName" label={t('features.Registrations.components.AccountRegistrationForm.name')} required maxLength="32" />
        <TextField name="userLastName" label={t('features.Registrations.components.AccountRegistrationForm.surname')} required maxLength="32" />
      </BoxDouble>

      <TelFieldTh required label={t('features.Clients.components.BasicInfoSectionShow.phone_number')}/>

      <TextField name="userEmail" label={t('features.Registrations.components.AccountRegistrationForm.email')} required validate={isEmail} maxLength="255"/>

      <div>
        <TextField name="userPassword" label={t('features.Registrations.components.AccountRegistrationForm.password')} type="password" required />
      </div>

      <TextField name="userPasswordConfirmation" label={t('features.Registrations.components.AccountRegistrationForm.password_confirm')} type="password" required />

      <CheckboxField
        name="agreeToTos"
        label="利用規約・プライバシーポリシー・個人情報の取り扱い"
        labelContent={ i18n.language === 'ja' ? 
        <span>
          &nbsp;<a
            className="u-txt-link"
            href="https://payrollth.jobcan.in.th/terms/"
            target="_blank"
            rel="noopener noreferrer"
          >
            利用規約
          </a>および
          <a
            className="u-txt-link"
            href="https://jobcan.ne.jp/privacypolicy"
            target="_blank"
            rel="noopener noreferrer"
          >
            プライバシーポリシー
          </a>、
          <a
            className="u-txt-link"
            href="https://payrollth.jobcan.in.th/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            個人情報の取り扱い
          </a>に同意します
        </span> : i18n.language === 'en' ? 
        <span>
          I agree to the 
          <a
            className="u-txt-link"
            href="https://payrollth.jobcan.in.th/terms/"
            target="_blank"
            rel="noopener noreferrer"
          > terms of use
          </a>,
          <a
            className="u-txt-link"
            href="https://jobcan.ne.jp/privacypolicy"
            target="_blank"
            rel="noopener noreferrer"
          > privacy policy
          </a> and
          <a
            className="u-txt-link"
            href="https://payrollth.jobcan.in.th/privacy"
            target="_blank"
            rel="noopener noreferrer"
          > personal information privacy
          </a>
        </span> : 
        <span>
          ฉันยอมรับใน
          <a
            className="u-txt-link"
            href="https://payrollth.jobcan.in.th/terms/"
            target="_blank"
            rel="noopener noreferrer"
          > ข้อตกลงในการใช้งาน
          </a>, 
          <a
            className="u-txt-link"
            href="https://jobcan.ne.jp/privacypolicy"
            target="_blank"
            rel="noopener noreferrer"
          > นโยบายความเป็นส่วนตัว
          </a> และ 
          <a
            className="u-txt-link"
            href="https://payrollth.jobcan.in.th/privacy"
            target="_blank"
            rel="noopener noreferrer"
          > นโยบายข้อมูลส่วนบุคคล
          </a> ของทางบริษัท
        </span>
        }
      />
      <div className="u-ta-c u-mt30">
        <Button onClick={submit} primary disabled={pristine || submitting || !agreeToTos}>
          {t('features.Registrations.components.AccountRegistrationForm.sign_up')}
        </Button>
      </div>
    </Section>
  </form>
)};

const AccountRegistrationForm = reduxForm({
  form: ACCOUNT_REGISTRATION_FORM
})(RawAccountRegistrationForm);

export default connect(
  state => ({
    agreeToTos: (getFormValues(ACCOUNT_REGISTRATION_FORM)(state) || {}).agreeToTos,
    errors: getRegistrationErrors(state)
  }),
  dispatch => ({
    onSubmit: data => dispatch(registerAccount(data))
  })
)(AccountRegistrationForm);
